/**
 * Utility function to insert a new entry into the browser history.
 *
 * @param {Object} args - The arguments object
 * @param {string} args.url - The URL to push to the browser history
 */
const insert_browser_history = function(args) {
    window.history.pushState({}, '', args.url);
};

export default insert_browser_history;
